import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import logo from "../../assets/w-logo.webp";
import hamburger from "../../assets/icons/hamburger.svg";
import cancel from "../../assets/icons/cancel.svg";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("/");
  const [isFixed, setIsFixed] = useState(false);
  const [headerContainerPadding, setHeaderContainerPadding] = useState(0);
  const location = useLocation();
  const headerRef = useRef<HTMLElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > headerRef.current.offsetHeight / 2) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
          setHeaderContainerPadding(headerRef.current.offsetHeight);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { href: "/", label: t('header.home') },
    { href: "/about", label: t('header.about') },
    { href: "/musicians", label: t('header.musicians') },
    { href: "/gallery", label: t('header.gallery') },
    { href: "/contact", label: t('header.contact') },
    { href: "/partners", label: t('header.partners') },
  ];

  return (
    <div className={styles.headerContainer} style={isFixed ? { paddingTop: headerContainerPadding } : {}}>
      <header ref={headerRef} className={`${styles.header} ${isFixed ? styles.fixed : ""}`}>
        <div className={styles.logo}>
          <a href="/" className={styles.logoLink}>
            <img src={logo} alt="logo" />
          </a>
        </div>
        <div className={styles.groupBtns}>
          <LanguageSwitch responsive={true} />
          <button className={styles.menuBtn} onClick={toggleMenu}>
            {isMenuOpen ? <img src={cancel} alt="menu" /> : <img src={hamburger} alt="menu" />}
          </button>
        </div>
        <nav className={`${styles.nav} ${isMenuOpen ? styles.open : ""}`}>
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={activeLink === item.href ? styles.active : ""}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/tickets" className={styles.buyTicketsBtn} onClick={() => setIsMenuOpen(false)}>
            {t('header.buyTicket')}
          </Link>
          <LanguageSwitch responsive={false} />
        </nav>
      </header>
    </div>
  );
};

export default Header;
